import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventInviteResent } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventInviteResent) => void

export const useEventResendInvite = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.InvitationResent, handler), [])
}
